export function isConvivialNativeAppWebView() {
    if (typeof window === 'undefined') return false;

    return Boolean(window.__CONVIVIAL_NATIVE_APP__);
}

export function postConvivialNativeMessage(message) {
    if (
        typeof window === 'undefined' ||
        !window.ConvivialNative ||
        typeof window.ConvivialNative.postMessage !== 'function'
    ) {
        return false;
    }

    window.ConvivialNative.postMessage(JSON.stringify(message));
    return true;
}

export async function logoutViaNativeApp(webLogout) {
    const isNativeApp = isConvivialNativeAppWebView();

    if (!isNativeApp) {
        await webLogout();
        return false;
    }

    postConvivialNativeMessage({
        type: 'logoutRequested',
    });

    try {
        await webLogout();

        postConvivialNativeMessage({
            type: 'webLogoutComplete',
        });
    } catch (error) {
        postConvivialNativeMessage({
            type: 'webLogoutFailed',
            error: error?.message || String(error),
        });
    }

    return true;
}

export function requestNativeLogin(redirectTo = '/index') {
    if (!isConvivialNativeAppWebView()) {
        return false;
    }

    return postConvivialNativeMessage({
        type: 'loginRequested',
        redirectTo,
    });
}

export function requestNativeShare({ title, text, url }) {
    if (!isConvivialNativeAppWebView()) {
        return false;
    }

    return postConvivialNativeMessage({
        type: 'shareRequested',
        title,
        text,
        url,
    });
}